import React, { useContext, useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import axios from "axios";
import Map from "../components/Map/Map";
import HomeLayout from "../components/layout/HomeLayout";
import * as FaIcons from "react-icons/fa";
import SiteItem from "../components/Map/SiteItem";
import InterestContext from "../context/interest/interestContext";
import LoadingOverlay from "../components/utilities/LoadingOverlay";
import { getsites, getMainDomainNew, loadBrands } from "../components/findBrand";
import ErrorLogger from "../components/ErrorLogger";
import  { getAppUrl, getLocationApiUrl } from "../functions/getEnv";
import states from "../data/states";
import setAuthToken from "../functions/auth_header";

const SearchLocationPage = () => {
  const interestContext = useContext(InterestContext);
  
  const {
    getZipLocations,
    getBrandbySite,
    brandSites,
    zipSites,
    stateSites,
    zipCoordinates,
    stateCoordinates,
    loading,
    zipSearch: { brandName: zipBrandName, zipcode },
    onZipSearchChange,
    setLoading,
    applyFilter,

    clearSearchResults, 
    } = interestContext;

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const chater = queryParams.get('id') || "NULL";
  const brand = getsites();
  const [mainDomain, setMainDomain] = useState(null);
  const appUrl = getAppUrl(import.meta.env.VITE_NODE_ENV);

  const [showValidationMsg, setShowValidationMsg] = useState(false);
  const [data, setData] = useState(null);
  const [mapLoding, setMapLoding] = useState(false);
  const [hasSearchData, setHasSearchData] = useState(false);
  
  // REMOVED: Local state for zipSite and stateSite - use context directly
  // const [zipSite, setZipSite] = useState(zipSites);
  // const [stateSite, setStateSites] = useState(stateSites);
  
  const [state1, setState1] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [showCards, setShowCards] = useState(false);
  const [brandsLoaded, setBrandsLoaded] = useState(false);
  const locationApiUrl = getLocationApiUrl(import.meta.env.VITE_NODE_ENV);

  // Wait for brands to load before rendering
  useEffect(() => {
    const waitForBrands = async () => {
      await loadBrands();
      setBrandsLoaded(true);
    };
    waitForBrands();
  }, []);
  
  // Check if mobile view
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Wait for data to be available before showing cards
  useEffect(() => {
    if ((brandSites?.length > 0) || (data?.length > 0) || (zipSites?.length > 0) || (stateSites?.length > 0)) {
      setShowCards(true);
    } else if (data !== null && data?.length === 0 && !loading) {
      // Also show cards (with "No locations" message) when data is explicitly empty and not loading
      setShowCards(true);
    }
  }, [brandSites, data, zipSites, stateSites, loading]); // Added zipSites, stateSites, and loading

  


  const getBrandName1 = async () => {
  try {
   // setLoading(true);
    let brand = getMainDomainNew();
    
    // Brand name mappings
    const brandMappings = {
       "elev8schools": "Elev8",
      "flexhigh": "Flex High", 
      "holstonacademy": "Holston",
      "pbiacademy": "Palm Beach International"
    };
    
    brand = brandMappings[brand] || brand;
    
   // console.log("Final brand name:", brand);
    
    const authRes = await axios.get(`${appUrl}/auth/webapp`);
    const userAccessToken = authRes.data.accessTokens[0];
    setAuthToken(userAccessToken);
    
    const res = await axios.get(`${locationApiUrl}/sites-bybrand/${brand}/${chater}`);
    
    // Handle the response properly
    if (res.data) {
      // If backend sends new format with success flag
      if (res.data.hasOwnProperty('success')) {
        if (res.data.success && res.data.data.length > 0) {
          setData(res.data.data);
        } else {
          // No sites found
          setData([]);
       
        }
      } else {
        // If backend still sends array directly (backward compatibility)
        if (Array.isArray(res.data) && res.data.length > 0) {
          setData(res.data);
        } else {
          setData([]);
          console.log("No sites found for brand: ${brand}");
        }
      }
    } else {
      setData([]);
    }
    
  } catch (error) {
    console.error("Error fetching brand sites:", error.message);
    ErrorLogger.logError(`Error in getBrandName1: ${error.message}`);
    setData([]); 
  }
};
  const getStateAbbreviationByName = (fullName) => {
    const state = states.find((state) => Object.values(state)[0] === fullName);
    return state ? Object.keys(state)[0] : null;
  };

  const capitalizeFirstLetter = (str) => {
    if (!str) return str;
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  //Helper function to check if state abbreviation is valid
  const isValidStateAbbreviation = (abbr) => {
    const validAbbreviations = states.map(state => Object.keys(state)[0]);
    return validAbbreviations.includes(abbr.toUpperCase());
  };

  localStorage.setItem("token", "");


  useEffect(() => {
    if (!brandsLoaded) return; // Wait for brands to load first

    getBrandbySite();
    getBrandName1();
    // REMOVED: setZipSite and setStateSites calls since we're using context directly

    const domain = getMainDomainNew();
    setMainDomain(domain);
  }, [brand, brandsLoaded]); // Added brandsLoaded dependency

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.jsdelivr.net/npm/@iframe-resizer/child@5.4.7";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // NEW: Clear previous results when search term changes
  const clearPreviousResults = () => {
    setState1(false);
    setHasSearchData(false);
    setMapLoding(false);
    setShowValidationMsg(false);
    
    if (clearSearchResults) {
      clearSearchResults();
    }
  };

  const onSubmit = async () => {
    // Clear previous results first
    clearPreviousResults();
    
    applyFilter();

    const trimmedZipcode = zipcode.trim();
    const isZipCode = /^\d{5}$/.test(trimmedZipcode);
    const formattedState = capitalizeFirstLetter(trimmedZipcode);
    const stateAbbreviation = getStateAbbreviationByName(formattedState);

    // Check for empty input
    if (!trimmedZipcode) {
      setShowValidationMsg(true);
    } else {
      setShowValidationMsg(false);
      setLoading(true);

      if (!isNaN(trimmedZipcode)) {
        if (trimmedZipcode.length === 5) {
          setMapLoding(false);
          setState1(false); 
          try {
            await getZipLocations(brand, "NULL", "NULL", trimmedZipcode, "NULL", chater);
            setHasSearchData(true);
          } catch (error) {
            setHasSearchData(true);
          } finally {
            setLoading(false);
            setMapLoding(false);
          }
        } else {
          setShowValidationMsg(true);
          setMapLoding(false);
          setHasSearchData(false);
        }
      } else if (stateAbbreviation) {
        setState1(true); 
        setMapLoding(true);
        try {
          await getZipLocations(brand, "NULL", "NULL", "NULL", stateAbbreviation, chater);
          setHasSearchData(true);
        } catch (error) {
          setShowValidationMsg(false);
          setHasSearchData(true);
        } finally {
          setLoading(false);
          setMapLoding(false);
        }
      } else if (isValidStateAbbreviation(trimmedZipcode)) { 
        setState1(true); 
        setMapLoding(true);
        try {
          await getZipLocations(brand, "NULL", "NULL", "NULL", trimmedZipcode.toUpperCase(), chater);
          setHasSearchData(true);
        } catch (error) {
          setShowValidationMsg(false);
          setHasSearchData(true);
        } finally {
          setLoading(false);
          setMapLoding(false);
        }
      } else {
        console.error("Invalid input: ZIP code or state name not recognized.");
        setLoading(false);
        setMapLoding(false);
        setShowValidationMsg(true);
      }
      setLoading(false);
    }
  };

  const clearInput = () => {
     window.location.reload();
  };

  const handleInputChange = (e) => {
    onZipSearchChange(e);
    
    
    if (e.target.value.trim() === '') {
      window.location.reload();
    }
  };

  return (
    <HomeLayout>
      {/* Learn4Life Hero Section */}
      {mainDomain === 'learn4life' && (
        <div className="learn4life-hero">
          <div className="hero-content">
            <h1 className="hero-heading">Find A Campus</h1>
          </div>
        </div>
      )}

      {/* Learn4Life Text Section */}
      {mainDomain === 'learn4life' && (
        <div className="learn4life-text-section">
          <h3 className="learn4life-instruction-text">
            To find the Learn4Life campus closest to you, please enter your ZIP code below.
          </h3>
        </div>
      )}
      
      <form className="map-form form">
        <div className="zip-search">
          <form>
            <div className={`input ${zipcode && zipcode.trim().length > 0 ? 'has-text' : ''}`}>
              <div className="search-row" style={{ display: "flex", alignItems: "center", flexWrap: "wrap", justifyContent: "center", gap: "15px" }}>
                
                {/* Wrap input and icon in a relative container */}
                <div className="input-wrapper" style={{ position: "relative", flexGrow: 1 }}>
                  <input
                    type="search"
                    name="zipcode"
                    maxLength={50}
                    placeholder="Find a location near you. Enter a ZIP code or state."
                    required
                    value={zipcode}
                    onChange={handleInputChange}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        onSubmit();
                      }
                    }}
                    autoComplete="off"
                  />

                  {/* Search Icon (Magnifying Glass) - shows when no text */}
                  {(!zipcode || zipcode.trim().length === 0) && (
                    <span className="search-icon">
                      <FaIcons.FaSearch />
                    </span>
                  )}

                  {/* Clear icon (X) - only shows when there's text */}
                  {zipcode && zipcode.trim().length > 0 && (
                    <button 
                      type="button"
                      className="clear-icon" 
                      onClick={clearInput}
                      aria-label="Clear search"
                    >
                      <FaIcons.FaTimes />  
                    </button>
                  )}
                </div>
                
                {/* Search Button */}
                <button type="button" className="btn search-btn" onClick={onSubmit}>
                  Search
                </button>
              </div>
            </div>

            {showValidationMsg && (
              <p className="validation-msg">
                Enter a valid ZIP code or state.
              </p>
            )}
          </form>
        </div>
        
        {/* Mobile Loading Overlay - Show when no cards are ready */}
        {isMobile && (!showCards || loading) && (
          <div className="mobile-search-loading">
            <LoadingOverlay isLoading={!showCards || loading} />
          </div>
        )}  

        {/* Main Results Container with Centered Loading */}
        <div className="zip-results" style={{ position: 'relative' }}>
          {/* Centered Loading Overlay for the entire results area */}
          {loading && (
              <LoadingOverlay isLoading={loading} />
          )}

          <div className="map-section">

            {state1 ? (
              <Map sites={stateSites} zipCoordinates={stateCoordinates} /> 
            ) : (
              <Map sites={zipSites} zipCoordinates={zipCoordinates} />  
            )}
          </div>

          <div className="site-container" >
            <div className="site-section">
              <div className="site-grid">
                {!showCards && !loading ? (
                                
                 <> 
                 {!isMobile && (
                   <div style={{ 
                     display: 'flex', 
                     justifyContent: 'center', 
                     alignItems: 'center', 
                     minHeight: '200px' 
                   }}>
                     <LoadingOverlay isLoading={!showCards} />
                   </div>
                 )}
                 </>
                ) :
                hasSearchData ? (
                  <>
             
                    {!state1 && zipSites?.length > 0 ? (
                     
                      zipSites.map((item) => (
                        <SiteItem key={item._id} site={item} loading={false}/>
                      ))
                    ) : state1 && stateSites?.length > 0 ? (
                    
                      stateSites.map((item) => (
                        <SiteItem key={item._id} site={item} loading={false} />
                      ))
                    ) : (
                 
                      <p style={{ 
                        color: "Black", 
                        textAlign: 'center', 
                        width: '100%',
                        padding: '20px',
                        fontSize: '16px' 
                      }}>
                        No results found for your search.
                      </p>
                    )}
                  </>
                ) : (
                  <>
                    {brandSites?.length > 0
                      ? brandSites.map((item) => (
                          <SiteItem key={item.id} site={item} loading={false} />
                        ))
                      : data &&
                        data.map((item) => (
                          <SiteItem key={item.id} site={item} loading={false} />
                        ))}
                  </>
                )}
                {
                  <>
                 { data && data.length === 0 && !loading && !hasSearchData && (
                 
                    <p style={{ 
                      fontSize: '20px'
                    }}>
                      No locations available for {brand}.
                    </p>
                  )     
                }
                 </>
                }
              </div>
            </div>
          </div>
        </div>
      </form>
    </HomeLayout>
  );
};

export default SearchLocationPage;